import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import { LoginPayload, DecodedToken } from 'types';
import jwtDecode from 'jwt-decode';
import { BASE_URL } from 'http/api';
import { API_AUTH_V1_LOGIN } from 'consts';
import { AxiosMethod, LoadingStatus, UserRoles } from 'enums';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';

class UserStore {
  role: UserRoles = UserRoles.USER;

  loginData = { email: '', password: '' };

  accessToken: string | null = null;

  refreshToken: string | null = null;

  status: LoadingStatus = LoadingStatus.IDLE;

  constructor() {
    makeAutoObservable(this);

    makePersistable(this, {
      name: 'UserStore',
      properties: ['loginData', 'accessToken', 'refreshToken'],
      storage: window.localStorage,
    });
  }

  async getAuthData({ email, password }: LoginPayload) {
    this.accessToken = null;
    this.status = LoadingStatus.PENDING;

    const data = await NetworkRequestHandler.sendRequest({
      method: AxiosMethod.POST,
      url: `${BASE_URL}${API_AUTH_V1_LOGIN}`,
      data: {
        email,
        password,
      },
    });

    runInAction(() => {
      this.loginData = { email, password };
      this.accessToken = data.tokens.accessToken;
      this.refreshToken = data.tokens.refreshToken;
      const tokenDecode: DecodedToken = jwtDecode(data.tokens.accessToken);
      if (tokenDecode.roles.includes('ADMIN')) {
        this.role = UserRoles.ADMIN;
      } else if (tokenDecode.roles.includes('SUPPORT')) {
        this.role = UserRoles.SUPPORT;
      } else {
        this.role = UserRoles.USER;
      }
      this.status = LoadingStatus.DONE;
    });
  }

  setRole(role: UserRoles) {
    this.role = role;
  }
}

export default new UserStore();
